/* Raxwrld Bolla — theme.js
   Vanilla, no dependencies. Every feature degrades to plain HTML when JS fails. */
(() => {
  'use strict';

  const R = window.Rax || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartType: 'drawer', strings: {} };
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const body = document.body;

  /* ---------- Money ---------- */
  function formatMoney(cents, format = R.moneyFormat || '€{{amount_with_comma_separator}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents) / 100;
    const fmt = (n, dec, thousands, decimal) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec ? decimal : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, '.', ',');
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2400);
  }

  /* ---------- Dialog drawers ---------- */
  function openDialog(dlg) {
    if (!dlg || dlg.open) return;
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    body.style.overflow = 'hidden';
  }
  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openDialog(document.getElementById(opener.dataset.open));
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }
    // Click on the backdrop closes the dialog
    if (e.target.tagName === 'DIALOG' && e.target.open) {
      const r = e.target.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDialog(e.target);
    }
  });
  $$('dialog').forEach((d) => d.addEventListener('close', () => { body.style.overflow = ''; }));

  /* ---------- Cart ---------- */
  const cartDrawer = () => $('[data-cart-drawer]');

  async function refreshCart(sectionsHtml) {
    let html = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!html) {
      const res = await fetch(`${R.routes.root.replace(/\/$/, '')}/?sections=cart-drawer`);
      html = (await res.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    const current = cartDrawer();
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      current.dataset.itemCount = fresh.dataset.itemCount;
      updateCount(Number(fresh.dataset.itemCount || 0));
    }
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.classList.toggle('is-empty', count === 0);
      const visible = el.querySelector('[aria-hidden]');
      if (visible) visible.textContent = count;
    });
  }

  async function addToCart(form, submitter) {
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    const res = await fetch(`${R.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || R.strings.cartError);
    return data;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form], form.pack__form, form.card__form, form.supplier__form');
    if (!form || !form.querySelector('[name="id"]')) return;
    const submitter = e.submitter;
    // "Buy now" buttons carry return_to=/checkout and go straight to checkout natively.
    if (submitter && submitter.name === 'return_to') return;
    if (R.cartType === 'page') return;
    e.preventDefault();
    const btn = submitter || form.querySelector('[type="submit"]');
    btn && btn.classList.add('is-loading');
    try {
      const data = await addToCart(form, btn);
      await refreshCart(data.sections);
      openDialog(cartDrawer());
    } catch (err) {
      toast(err.message || R.strings.cartError);
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  });

  // Quantity changes inside the drawer
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    const drawer = cartDrawer();
    drawer && drawer.classList.add('is-busy');
    try {
      const res = await fetch(`${R.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.lineIndex), quantity: Number(b.dataset.qtyChange), sections: ['cart-drawer'] }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || R.strings.cartError);
      await refreshCart(data.sections);
    } catch (err) {
      toast(err.message || R.strings.cartError);
    } finally {
      drawer && drawer.classList.remove('is-busy');
    }
  });

  // Header cart icon opens the drawer instead of navigating
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-open-cart]');
    if (!link || R.cartType === 'page' || !cartDrawer()) return;
    e.preventDefault();
    openDialog(cartDrawer());
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    const form = $('form[data-product-form]', root);
    const picker = $('[data-variant-picker]', root);
    const idInput = form && $('[data-variant-id]', form);
    const stickyBar = $('[data-sticky-atc]', root);

    // Quantity stepper
    $$('[data-qty-step]', root).forEach((b) => b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value || 1) + Number(b.dataset.qtyStep));
    }));

    // Variant picker
    if (picker && idInput) {
      const variants = JSON.parse($('[data-variants-json]', picker).textContent);
      picker.addEventListener('change', () => {
        const chosen = $$('fieldset', picker).map((fs) => {
          const c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
        const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
        updateVariant(v);
      });

      function updateVariant(v) {
        const buyBtn = $('[data-buy-now]', root);
        const addBtn = $('[data-add-button]', root);
        const stickyBtn = $('[data-sticky-btn]', root);
        const available = Boolean(v && v.available);
        [buyBtn, addBtn, stickyBtn].forEach((b) => { if (b) b.disabled = !available; });
        const buyLabel = $('[data-buy-label]', root);
        if (buyLabel) {
          if (!buyLabel.dataset.default) buyLabel.dataset.default = buyLabel.textContent;
          buyLabel.textContent = !v ? R.strings.unavailable : available ? buyLabel.dataset.default : R.strings.soldOut;
        }
        if (!v) return;
        idInput.value = v.id;
        const now = $('[data-price-now]', root);
        const was = $('[data-price-was]', root);
        const save = $('[data-price-save]', root);
        if (now) now.textContent = formatMoney(v.price);
        const priceBox = now && now.closest('[data-price]');
        const compareAllowed = !priceBox || priceBox.dataset.compareAllowed !== 'false';
        const onSale = compareAllowed && v.compare_at_price && v.compare_at_price > v.price;
        if (was) { was.hidden = !onSale; if (onSale) was.textContent = formatMoney(v.compare_at_price); }
        if (save) { save.hidden = !onSale; if (onSale) save.textContent = `-${Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price)}%`; }
        const priceWrap = now && now.closest('.price');
        if (priceWrap) priceWrap.classList.toggle('price--sale', Boolean(onSale));
        const sp = $('[data-sticky-price]', root);
        if (sp) sp.textContent = formatMoney(v.price);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (v.featured_media) {
          const slide = $(`[data-media-id="${v.featured_media.id}"]`, root);
          if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
      }
    }

    // Gallery dots (mobile scroll-snap)
    const gallery = $('[data-gallery]', root);
    const dots = $$('.pdp__dot', root);
    if (gallery && dots.length) {
      let raf;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
          dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
        });
      }, { passive: true });
    }

    // Sticky add-to-cart: visible once the main buttons leave the viewport (below them)
    const mainAtc = $('[data-main-atc]', root);
    if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', past);
        stickyBar.setAttribute('aria-hidden', String(!past));
        const btn = $('[data-sticky-btn]', stickyBar);
        if (btn) btn.tabIndex = past ? 0 : -1;
      });
      io.observe(mainAtc);
    }
  }
  $$('[data-product]').forEach(initProduct);

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const res = await fetch(el.dataset.url);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (_) { /* recommendations are optional */ }
  });

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    const end = Date.parse(el.dataset.countdown);
    if (Number.isNaN(end)) return;
    const parts = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
    const pad = (n) => String(n).padStart(2, '0');
    let timer;
    const tick = () => {
      const diff = end - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        el.classList.add('is-ended');
        el.textContent = el.dataset.ended || '';
        return;
      }
      const s = Math.floor(diff / 1000);
      if (parts.d) parts.d.textContent = pad(Math.floor(s / 86400));
      if (parts.h) parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (parts.m) parts.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (parts.s) parts.s.textContent = pad(s % 60);
    };
    tick();
    timer = setInterval(tick, 1000);
  }
  $$('[data-countdown]').forEach(initCountdown);

  /* ---------- Client-side filters (search box + tabs) ---------- */
  $$('[data-filter-scope]').forEach((scope) => {
    const input = $('[data-filter-input]', scope);
    const tabs = $$('[data-filter-tab]', scope);
    const items = $$('[data-search]', scope);
    const count = $('[data-filter-count]', scope);
    const empty = $('[data-filter-empty]', scope);
    let group = '*';
    const apply = () => {
      const q = input ? input.value.trim().toLowerCase() : '';
      let shown = 0;
      items.forEach((it) => {
        const cardGroup = it.dataset.group || (it.querySelector('[data-group]') || {}).dataset?.group;
        const okText = !q || it.dataset.search.includes(q);
        const okGroup = group === '*' || cardGroup === group;
        const visible = okText && okGroup;
        const target = it.closest('li') || it;
        target.hidden = !visible;
        if (visible) shown += 1;
      });
      if (count) count.textContent = shown;
      if (empty) empty.hidden = shown !== 0;
    };
    input && input.addEventListener('input', apply);
    tabs.forEach((t) => t.addEventListener('click', () => {
      group = t.dataset.filterTab;
      tabs.forEach((x) => { x.classList.toggle('is-on', x === t); x.setAttribute('aria-pressed', String(x === t)); });
      apply();
    }));
  });

  // Sorting select submits on change
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  /* ---------- Copy link ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-copy]');
    if (!b) return;
    try {
      await navigator.clipboard.writeText(b.dataset.copy);
      toast(R.strings.copied || 'Copiato');
    } catch (_) {
      window.prompt('', b.dataset.copy);
    }
  });

  // In-app browsers (TikTok / Instagram) often block t.me links: show the hint there.
  if (/TikTok|musical_ly|Bytedance|Instagram|FBAN|FBAV/i.test(navigator.userAgent)) {
    $$('[data-inapp-tip]').forEach((el) => { el.hidden = false; });
  }

  /* ---------- Login / recover toggle ---------- */
  $$('[data-toggle-recover]').forEach((a) => a.addEventListener('click', (e) => {
    e.preventDefault();
    const rec = $('#RecoverForm');
    const log = $('#LoginForm');
    if (!rec || !log) return;
    const showRecover = rec.hidden;
    rec.hidden = !showRecover;
    log.hidden = showRecover;
  }));
  if (window.location.hash === '#recover' && $('#RecoverForm')) {
    $('#RecoverForm').hidden = false;
    $('#LoginForm').hidden = true;
  }

  /* ---------- UGC videos: play on tap, pause off-screen ---------- */
  $$('[data-ugc-video]').forEach((wrap) => {
    const v = $('video', wrap);
    const btn = $('.ugc__play', wrap);
    if (!v || !btn) return;
    btn.addEventListener('click', () => {
      if (v.paused) { v.play(); wrap.classList.add('is-playing'); } else { v.pause(); wrap.classList.remove('is-playing'); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { if (!en.isIntersecting && !v.paused) { v.pause(); wrap.classList.remove('is-playing'); } }).observe(v);
    }
  });

  /* ---------- Reveal on scroll (section heads only) ---------- */
  const scrollDriven = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  if (scrollDriven) document.documentElement.classList.add('sda');
  if (body.dataset.revealEnabled === 'true' && !scrollDriven) {
    const els = $$('[data-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      els.forEach((el) => io.observe(el));
    } else {
      els.forEach((el) => el.classList.add('is-in'));
    }
  }

  /* ---------- Window lines slide with scroll (fallback without scroll-driven CSS) ---------- */
  const lines = $$('.window__line');
  if (lines.length && !scrollDriven && !reducedMotion.matches) {
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      lines.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) return;
        const p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        const x = el.classList.contains('window__line--rev') ? -35 + p * 70 : 35 - p * 70;
        el.style.transform = `translate3d(${x.toFixed(2)}vw, 0, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Desktop-only motion: parallax, magnetic, cursor ---------- */
  function desktopMotion() {
    if (reducedMotion.matches) return;

    // Parallax: transform only, rAF throttled, only while on screen
    const pEls = $$('[data-parallax]');
    if (pEls.length) {
      const visible = new Set();
      const io = new IntersectionObserver((entries) => entries.forEach((en) => (en.isIntersecting ? visible.add(en.target) : visible.delete(en.target))));
      pEls.forEach((el) => io.observe(el));
      let ticking = false;
      const update = () => {
        const vh = window.innerHeight;
        visible.forEach((el) => {
          const r = el.getBoundingClientRect();
          const offset = (r.top + r.height / 2 - vh / 2) * Number(el.dataset.parallax || 0.1);
          el.style.transform = `translate3d(0, ${(-offset).toFixed(1)}px, 0)`;
        });
        ticking = false;
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }

    if (!finePointer.matches) return;

    // Magnetic buttons
    if (body.dataset.magnetic === 'true') {
      $$('[data-magnetic]').forEach((el) => {
        const strength = 0.25;
        el.addEventListener('pointermove', (e) => {
          const r = el.getBoundingClientRect();
          el.style.setProperty('--mx', `${((e.clientX - r.left - r.width / 2) * strength).toFixed(1)}px`);
          el.style.setProperty('--my', `${((e.clientY - r.top - r.height / 2) * strength).toFixed(1)}px`);
        });
        el.addEventListener('pointerleave', () => {
          el.style.setProperty('--mx', '0px');
          el.style.setProperty('--my', '0px');
        });
      });
    }

    // Custom cursor: a dot that follows with a little lag
    const cursor = $('.cursor');
    if (cursor && body.dataset.cursor === 'true') {
      document.documentElement.classList.add('has-cursor');
      let x = -100; let y = -100; let cx = x; let cy = y; let running = false;
      const loop = () => {
        cx += (x - cx) * 0.25;
        cy += (y - cy) * 0.25;
        cursor.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
        if (Math.abs(x - cx) > 0.1 || Math.abs(y - cy) > 0.1) requestAnimationFrame(loop);
        else running = false;
      };
      window.addEventListener('pointermove', (e) => {
        x = e.clientX; y = e.clientY;
        cursor.classList.remove('is-hidden');
        if (!running) { running = true; requestAnimationFrame(loop); }
      }, { passive: true });
      document.addEventListener('pointerleave', () => cursor.classList.add('is-hidden'));
      document.addEventListener('pointerover', (e) => {
        cursor.classList.toggle('is-hover', Boolean(e.target.closest('a, button, label, summary, input, select, textarea')));
        cursor.classList.toggle('is-card', Boolean(e.target.closest('.card, .pack, .drop__product')));
      });
    }
  }
  desktopMotion();

  /* ---------- 3D warehouse world (lazy, after load, with 2D fallback) ---------- */
  function initWorld(host) {
    if (!host || host.dataset.mounted) return;
    const src = host.getAttribute('data-3d-src');
    if (!src || !document.documentElement.classList.contains('can-3d')) return;
    host.dataset.mounted = '1';
    const optsEl = host.querySelector('[data-3d-opts]');
    let opts = {};
    try { opts = JSON.parse(optsEl ? optsEl.textContent : '{}'); } catch (_) { /* defaults */ }
    opts.mobile = window.matchMedia('(max-width: 749px)').matches;
    opts.reducedMotion = reducedMotion.matches;
    const start = async () => {
      try {
        // canvas textures need the real fonts, not fallbacks
        if (document.fonts && document.fonts.ready) await Promise.race([document.fonts.ready, new Promise((r) => setTimeout(r, 1500))]);
        const mod = await import(new URL(src, window.location.href).href);
        host._rax3d = mod.mount(host, opts);
      } catch (err) {
        console.warn('[rax-world] fallback to 2D:', err);
        document.documentElement.classList.remove('can-3d', 'is-world');
      }
    };
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
    const go = () => {
      // phones: wait for the first touch or scroll (or a few seconds) so the page settles first
      if (!opts.mobile) { idle(start, { timeout: 2500 }); return; }
      let fired = false;
      const once = () => { if (fired) return; fired = true; idle(start, { timeout: 1500 }); };
      ['touchstart', 'scroll', 'pointerdown'].forEach((ev) => window.addEventListener(ev, once, { once: true, passive: true }));
      setTimeout(once, 3500);
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }
  $$('[data-world]').forEach(initWorld);

  /* ---------- Tracking rail: page scroll as a parcel's journey ---------- */
  const rail = $('[data-rail]');
  if (rail) {
    const stops = $$('.rail__stop', rail);
    let ticking = false;
    const update = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      rail.style.setProperty('--p', p.toFixed(4));
      let current = -1;
      stops.forEach((el, i) => { const done = p + 0.001 >= Number(el.dataset.at); el.classList.toggle('is-done', done); if (done) current = i; });
      stops.forEach((el, i) => el.classList.toggle('is-current', i === current));
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Card tilt (desktop pointer only) ---------- */
  if (body.dataset.tilt === 'true' && finePointer.matches && !reducedMotion.matches) {
    $$('.pack, .card, .supplier').forEach((el) => {
      el.classList.add('is-tiltable');
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;
        const py = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ry', `${(px * 10).toFixed(2)}deg`);
        el.style.setProperty('--rx', `${(-py * 10).toFixed(2)}deg`);
        el.style.setProperty('--gx', `${((px + 0.5) * 100).toFixed(1)}%`);
        el.style.setProperty('--gy', `${((py + 0.5) * 100).toFixed(1)}%`);
      });
      el.addEventListener('pointerleave', () => {
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Tape transition between pages ---------- */
  // The leaving page slides three bands of packing tape over the screen; the next page
  // starts covered (inline script in theme.liquid adds .tape-in) and peels them off.
  const html = document.documentElement;
  if (html.classList.contains('tape-on')) {
    setTimeout(() => html.classList.remove('tape-in', 'tape-intro'), 1700);
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.hasAttribute('data-no-tape')) return;
      const url = new URL(a.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return; // same page / anchors
      if (/^\/(checkout|account)/.test(url.pathname)) return;
      e.preventDefault();
      html.classList.remove('tape-in', 'tape-intro');
      html.classList.add('is-leaving');
      try { sessionStorage.setItem('rax-tape', '1'); } catch (_) { /* private mode: no peel-off, still navigates */ }
      setTimeout(() => { window.location.href = url.href; }, 460);
    });
    // back/forward cache restores the covered page: uncover it
    window.addEventListener('pageshow', (e) => { if (e.persisted) html.classList.remove('is-leaving'); });
  }

  /* ---------- Label gun: every click sticks a price label (desktop) ---------- */
  if (body.dataset.labelGun === 'true' && finePointer.matches && !reducedMotion.matches) {
    const texts = (R.stickers || []).map((t) => t.trim()).filter(Boolean);
    const live = [];
    if (texts.length) {
      document.addEventListener('pointerdown', (e) => {
        if (e.button !== 0 || e.target.closest('input, textarea, select, [contenteditable], dialog, .drawer')) return;
        const el = document.createElement('span');
        el.className = 'sticker' + (Math.random() < 0.3 ? ' sticker--accent' : '');
        el.setAttribute('aria-hidden', 'true');
        el.textContent = texts[Math.floor(Math.random() * texts.length)];
        el.style.setProperty('--x', `${e.clientX}px`);
        el.style.setProperty('--y', `${e.clientY}px`);
        el.style.setProperty('--r', `${(Math.random() * 24 - 12).toFixed(1)}deg`);
        body.appendChild(el);
        live.push(el);
        if (live.length > 8) live.shift().remove();
        requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-on')));
        setTimeout(() => { el.classList.add('is-off'); }, 900);
        setTimeout(() => { el.remove(); const i = live.indexOf(el); if (i > -1) live.splice(i, 1); }, 1200);
      }, { passive: true });
    }
  }

  /* ---------- Section titles decode like a label printer ---------- */
  if (body.dataset.scramble === 'true' && !reducedMotion.matches && 'IntersectionObserver' in window) {
    const glyphs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789€#';
    const scramble = (el) => {
      const final = el.textContent;
      const chars = [...final];
      const dur = Math.min(900, 380 + chars.length * 18);
      el.setAttribute('aria-label', final.trim());
      el.style.minHeight = `${el.offsetHeight}px`;
      const t0 = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - t0) / dur);
        const solved = Math.floor(p * chars.length);
        el.textContent = chars.map((c, i) => (i < solved || /\s/.test(c) ? c : glyphs[Math.floor(Math.random() * glyphs.length)])).join('');
        if (p < 1) requestAnimationFrame(step);
        else { el.textContent = final; el.removeAttribute('aria-label'); el.style.minHeight = ''; }
      };
      requestAnimationFrame(step);
      // rAF is throttled in background tabs: make sure the real title always comes back
      setTimeout(() => { el.textContent = final; el.removeAttribute('aria-label'); el.style.minHeight = ''; }, dur + 400);
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { io.unobserve(en.target); scramble(en.target); } });
    }, { rootMargin: '0px 0px -15% 0px' });
    // only plain-text titles: markup inside (em, spans) would be flattened
    $$('.main h2.h2').filter((el) => el.children.length === 0 && el.textContent.trim().length < 60).forEach((el) => io.observe(el));
  }

  /* ---------- Cookie preferences (Shopify's own privacy banner) ---------- */
  const showCookiePrefs = () => {
    const btn = $('[data-cookie-prefs]');
    if (btn && window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      btn.hidden = false;
      btn.addEventListener('click', () => window.privacyBanner.showPreferences());
    }
  };
  if (document.readyState === 'complete') showCookiePrefs(); else window.addEventListener('load', showCookiePrefs, { once: true });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:unload', (e) => {
    $$('[data-world]', e.target).forEach((w) => { if (w._rax3d) w._rax3d.destroy(); });
  });
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-countdown]', e.target).forEach(initCountdown);
    $$('[data-product]', e.target).forEach(initProduct);
    $$('[data-world]', e.target).forEach(initWorld);
    $$('[data-reveal]', e.target).forEach((el) => el.classList.add('is-in'));
  });
})();
